// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__D3N_1","col":"styles_col__30L8h"};